import RemoteControlModalShared from '@shared/remote-control/RemoteControlModal.jsx';
import { subscribe, send } from '../utils/wsAdmin';

/**
 * Take Control, for an OPERATOR (superadmin).
 *
 * The component itself lives in `shared/remote-control/RemoteControlModal.jsx`
 * and is shared with the cafe-admin dashboard — edit it THERE, not here. This
 * file exists only to hand it this app's websocket and the target cafe.
 *
 * `cafeId` is REQUIRED here and is the only real difference between the two
 * apps. A superadmin token carries no cafe, so `app/ws/admin.py`'s superadmin
 * branch will not act on a message that does not name one — it has nothing to
 * scope the relay key to. Exactly the shape `ScreenMirrorModal` in this app
 * already uses.
 *
 * WHY THIS EXISTS AT ALL: requirement 5 of remote_control.md is "available on
 * demand to admin / superadmin", and the doc's goal statement names "the
 * operator (from anywhere)" BEFORE the cafe admin. It was assumed met for
 * months because a superadmin PASSES every permission check — but the
 * permission being right does not help someone with nowhere to click. The
 * operator is the case the feature exists for: a cafe admin at the counter can
 * walk to the PC, and someone diagnosing a cafe remotely cannot.
 */
const RemoteControlModal = ({ pc, cafeId, onClose, clientId }) => (
    <RemoteControlModalShared
        pc={pc}
        cafeId={cafeId}
        onClose={onClose}
        clientId={clientId}
        subscribeWs={subscribe}
        sendWs={send}
    />
);

export default RemoteControlModal;
